



























































import {Component, Prop, Vue} from "vue-property-decorator";
import {STemplateElement} from "./dto/STemplateElement";
import {SourceConstant} from "./const/SourceConstant";
import {STemplateElementAttr} from "@/components/dto/STemplateElementAttr";
import {SourceGenerator} from "@/components/utils/SourceGenerator";
import {SComponentsGroup} from "@/components/dto/SComponentsGroup";
import {SComponents} from "@/components/dto/SComponents";


@Component
export default class SourceTemplate extends Vue {
    @Prop() item!: STemplateElement;
    @Prop() basicComponent!: SComponentsGroup[];
    private isOpen: boolean = false;
    private isFolder: boolean = false;
    private lt: string = SourceConstant.lt;
    private gt: string = SourceConstant.gt;
    private slash: string = SourceConstant.slash;
    private colon: string = SourceConstant.colon;
    private quatationMakrs: string = SourceConstant.quatationMakrs;
    private equals: string = SourceConstant.equals;

    constructor(){
        super();
        this.isFolder = this.folder();
    }

    folder(){
        if(this.item.body.length == 0){
            return false;
        }else {
            return true;
        }
    }

    propValueType(value: any): string{
        if(typeof value === 'boolean'){
            return 'checkbox';
        }else if(typeof value === 'string'){
            return 'inputString';
        }else if(typeof value === 'number'){
            return 'inputNumber'
        }else{
            return '';
        }
    }

    toggleItem(){
        if(this.isFolder){
            this.isOpen = !this.isOpen;
        }
    }

    get elementAttribute():STemplateElementAttr[]{
        let attributes: STemplateElementAttr[] = [];
        this.item.elementAttr.forEach(
            attr => {
                let storeComponent = this.findStoreComponent(this.item.elementName);
                if(storeComponent !=  null){
                    let storeComponentAttr:STemplateElementAttr[] = SourceGenerator.generateAttribute(storeComponent.component.data);
                    attributes.push(...storeComponentAttr.filter(storeAttr => storeAttr.name === attr.name && storeAttr.value != attr.value));
                }
            });
        return attributes;
    }

    findStoreComponent(componentName: string):SComponents {
        let finded:any = null;
        this.basicComponent.forEach(basic =>{
            let storeComponent = basic.components.find(item  => item.component.component.name === componentName);
            if(storeComponent){
                finded = storeComponent;
            }
        });
        return finded;
    }

    makeFolder(){
        if(!this.isFolder){
            this.$emit('make-folder', this.item);
            this.isOpen = true;
        }
    }
}
